module.exports = __webpack_public_path__ + "img/0f4e13552ba873108147acf5e16594c.6fa5d1fb.jpg";